export default __webpack_public_path__ + "static/media/Cand_Nric_List_Template.4bdfb30e.xlsx";